import { IpuService } from "../../../services/IpuService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import IpuForm from "../../../components/forms/IpuForm.vue";

export default {
    name: "EditarIpu",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    components: {
        Breadcrumb,
        IpuForm,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de IPUs',
                disabled: false,
                href: '/gerenciar-ipus',
            },
            {
                text: 'Editar IPU',
                disabled: true
            }
        ],
        ipuData: {},
        loading: false,
    }),
    created() {
        this.carregarIpu(this.$route.params.id);
    },
    methods: {
        async handleSave(formData) {
            try {
                this.loading = true;
                
                // Converter dados do formulário para FormData
                const postData = new FormData();
                postData.append("exercicio", formData.exercicio);
                postData.append("codigo_ipu", formData.codigo_ipu);
                postData.append("descricao", formData.descricao);
                postData.append("ativo", formData.ativo ? 1 : 0);

                // Atualizar o IPU
                const response = await IpuService.update(this.$route.params.id, postData);
                
                if (response) {
                    // Redirecionar para a listagem
                    this.$router.push('/gerenciar-ipus');
                } else {
                    throw new Error('Erro ao atualizar IPU');
                }
            } catch (error) {
                console.error('Erro ao atualizar IPU:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-ipus');
        },
        async carregarIpu(id) {
            try {
                const response = await IpuService.show(id);

                if (response) {
                    const data = response.data;
                    // Passa os dados crus para o IpuForm via prop initialData
                    this.ipuData = data;
                } else {
                    console.error('Não foi possível carregar os dados do IPU.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados do IPU:', error);
            }
        }
    }
};
